import { render, staticRenderFns } from "./InvalidSubscription.vue?vue&type=template&id=2b0403d1&"
import script from "./InvalidSubscription.vue?vue&type=script&lang=js&"
export * from "./InvalidSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports